"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyQuestionStatusesResponseToJSON = exports.SurveyQuestionStatusesResponseFromJSONTyped = exports.SurveyQuestionStatusesResponseFromJSON = exports.instanceOfSurveyQuestionStatusesResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the SurveyQuestionStatusesResponse interface.
 */
function instanceOfSurveyQuestionStatusesResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyQuestionStatusesResponse = instanceOfSurveyQuestionStatusesResponse;
function SurveyQuestionStatusesResponseFromJSON(json) {
    return SurveyQuestionStatusesResponseFromJSONTyped(json, false);
}
exports.SurveyQuestionStatusesResponseFromJSON = SurveyQuestionStatusesResponseFromJSON;
function SurveyQuestionStatusesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'surveyQuestionId': !(0, runtime_1.exists)(json, 'survey_question_id') ? undefined : json['survey_question_id'],
        'adSetControlId': !(0, runtime_1.exists)(json, 'ad_set_control_id') ? undefined : json['ad_set_control_id'],
        'adSetExposedId': !(0, runtime_1.exists)(json, 'ad_set_exposed_id') ? undefined : json['ad_set_exposed_id'],
        'isAdSetControlMapped': !(0, runtime_1.exists)(json, 'is_ad_set_control_mapped') ? undefined : json['is_ad_set_control_mapped'],
        'isAdSetExposedMapped': !(0, runtime_1.exists)(json, 'is_ad_set_exposed_mapped') ? undefined : json['is_ad_set_exposed_mapped'],
        'creativeExposedId': !(0, runtime_1.exists)(json, 'creative_exposed_id') ? undefined : json['creative_exposed_id'],
        'creativeControlId': !(0, runtime_1.exists)(json, 'creative_control_id') ? undefined : json['creative_control_id'],
        'assetId': !(0, runtime_1.exists)(json, 'asset_id') ? undefined : json['asset_id'],
    };
}
exports.SurveyQuestionStatusesResponseFromJSONTyped = SurveyQuestionStatusesResponseFromJSONTyped;
function SurveyQuestionStatusesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'survey_question_id': value.surveyQuestionId,
        'ad_set_control_id': value.adSetControlId,
        'ad_set_exposed_id': value.adSetExposedId,
        'is_ad_set_control_mapped': value.isAdSetControlMapped,
        'is_ad_set_exposed_mapped': value.isAdSetExposedMapped,
        'creative_exposed_id': value.creativeExposedId,
        'creative_control_id': value.creativeControlId,
        'asset_id': value.assetId,
    };
}
exports.SurveyQuestionStatusesResponseToJSON = SurveyQuestionStatusesResponseToJSON;
